<template>
  <div class="h-[1px] w-full border-0 bg-gray1"></div>
</template>
